// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type SupportAgent40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const SupportAgent40: FC<SupportAgent40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
            viewBox="0 0 40 40"
        >
            <path d="M18.343 35v-2.778h13.89V19.833q0-5.06-3.558-8.585T20.01 7.722t-8.665 3.526q-3.557 3.524-3.557 8.585V30H6.677a3.2 3.2 0 0 1-2.354-.98 3.2 3.2 0 0 1-.98-2.353v-3.334q0-.875.438-1.645a3.26 3.26 0 0 1 1.23-1.23l.124-2.208q.333-2.834 1.646-5.25a15.8 15.8 0 0 1 3.292-4.208A14.6 14.6 0 0 1 14.614 6a14.7 14.7 0 0 1 5.396-1q2.833 0 5.375 1a15.2 15.2 0 0 1 4.542 2.77 15 15 0 0 1 3.291 4.188 15.3 15.3 0 0 1 1.667 5.25l.125 2.167q.792.375 1.23 1.125.436.75.437 1.583v3.834q0 .833-.438 1.583-.437.75-1.229 1.125v2.597q0 1.146-.816 1.962a2.68 2.68 0 0 1-1.962.816zm-3.338-11.945q-.592 0-.988-.4a1.36 1.36 0 0 1-.396-.993q0-.592.4-.988.403-.396.994-.396.592 0 .988.4.396.402.396.994 0 .591-.4.988a1.36 1.36 0 0 1-.994.395m10 0q-.592 0-.988-.4a1.36 1.36 0 0 1-.396-.993q0-.592.4-.988.402-.396.994-.396t.988.4q.396.402.396.994 0 .591-.4.988a1.36 1.36 0 0 1-.994.395M10.052 20.75q-.292-4.416 2.666-7.583Q15.678 10 20.093 10q3.654 0 6.368 2.382 2.715 2.381 3.3 5.993-3.738-.042-6.841-2.07-3.105-2.027-4.793-5.388a13.2 13.2 0 0 1-2.804 5.937 13.3 13.3 0 0 1-5.271 3.896" />
        </svg>
    );
};

export default SupportAgent40;
